import React from 'react';
import Box from '@mui/material/Box';

export default function Loading() {
    return (
        <Box display="flex" mt={4} justifyContent="center">
            <h1>Sorry, an error occurred.</h1>
        </Box>
    );
}
